import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TagModule } from 'primeng/tag';
import { StepsModule } from 'primeng/steps';
import { EventsComponent } from './components/events/events.component';
import { EventsFiltersComponent } from './components/events-filter/events-filters.component';
import { EventsTableComponent } from './components/events-table/events-table.component';
import { SharedModule } from '../shared/shared.module';
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
    declarations: [
        EventsComponent,
        EventsFiltersComponent,
        EventsTableComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule,
        CdkTreeModule,
        BlockableDivModule,
        // primeng modules
        BlockUIModule,
        ButtonModule,
        InputTextModule,
        FormsModule,
        TabViewModule,
        TableModule,
        FullCalendarModule,
        TagModule,
        StepsModule,
        DropdownModule,
        CalendarModule,
        ProgressSpinnerModule,
    ],
    exports: [
        EventsComponent
    ]
})
export class EventsModule { }
